export default __webpack_public_path__ + "static/media/cat-order-confirm.4a372892.svg";